import {Component, EventEmitter, Inject, Input, OnInit, Output, ViewChild} from '@angular/core';
import {PriorityComponent} from '../priority/priority.component';
import {APP_CONFIG, AppConfig} from '../../../../app-config.module';
import { StrtPriority } from '../../../../shared/models/plan/StrtPriority';
import {PlanStep} from '../../../services/PlanStep';
import {IPurposeMissionBeliefs} from '../../../services/IPurposeMissionBeliefs';
import {PlanCoordinate} from '../../../services/plan-coordinate';
import {StepComponent} from '../../step.component';
import {StrategiesPermissionsService} from '../../../services/strategies-permissions.service';
import {PriorityService} from '../../../services/priority.service';
import {IPrioritySort} from '../../../services/IPrioritySort';
import {ResourceService} from '../../../services/resource.service';

@Component({
  selector: 'app-synthesize-results',
  templateUrl: './synthesize-results.component.html',
  styleUrls: ['./synthesize-results.component.scss']
})
export class SynthesizeResultsComponent extends StepComponent<StrtPriority> implements OnInit {

  readonly MAX_PURPOSE_LENGTH = 300;
  readonly MAX_MISSION_LENGTH = 300;
  readonly MAX_BELIEFS_LENGTH = 300;
  private pColors: Array<string> = [];

  @ViewChild(PriorityComponent) private priorityComp: PriorityComponent;

  @Output() updateMission = new EventEmitter<string>();
  @Output() updatePurpose = new EventEmitter<string>();
  @Output() updateBeliefs = new EventEmitter<string>();
  @Output() priorityCreate = new EventEmitter<StrtPriority>();
  @Output() priorityEdit = new EventEmitter<StrtPriority>();
  @Output() prioritySort = new EventEmitter<number>();
  @Output() prioritySortFail = new EventEmitter<PlanCoordinate>();

  @Input() purposeMissionBeliefs: IPurposeMissionBeliefs;
  @Input() strategyId: number;

  private _priorities: StrtPriority[];

  private _prioritySort: IPrioritySort;

  reorderInProgress = false;
  reorderFailed = false;

  constructor(@Inject(APP_CONFIG) private appConfig: AppConfig,
              private permService: StrategiesPermissionsService,
              private priorityService: PriorityService,
              _resourceService: ResourceService) {
    super(PlanCoordinate.stepBy(PlanStep.SYNTHESIZE_RESULTS), _resourceService);
  }

  ngOnInit() { }

  @Input()
  set priorities(priorities: StrtPriority[]) {
    if (priorities) {
      if (this.pColors.length === 0) {
        for (const px of priorities) {
          this.pColors.push(px.colorCode);
        }
      }
      this._priorities = priorities;
      this._prioritySort = {
        strategyId: this.strategyId,
        originalPriorityIds: this.priorities.map((priority: StrtPriority) => {
          return priority.priorityId;
        }),
        sortedPriorityIds: []
      };
    }
  }

  get priorities(): StrtPriority[] {
    return this._priorities;
  }

  isViewer(): boolean {
    return this.permService.isUserViewer();
  }

  get purpose() {
    return this.purposeMissionBeliefs.purpose;
  }

  set purpose(purpose) {
    this.purposeMissionBeliefs.purpose = purpose;
  }

  get mission() {
    return this.purposeMissionBeliefs.mission;
  }

  set mission(mission) {
    this.purposeMissionBeliefs.mission = mission;
  }

  get beliefs() {
    return this.purposeMissionBeliefs.beliefs;
  }

  set beliefs(beliefs) {
    this.purposeMissionBeliefs.beliefs = beliefs;
  }

  get isPriorityActive() {
    return this.priorityComp.isActive;
  }

  set isPriorityActive(isActive) {
    this.priorityComp.isActive = isActive;
  }

  get isAddPrioritiesDisabled() {
    return !(this.permissions.canEditBody && this.priorities.length < this.appConfig.businessRules.MAX_PRIORITY_COUNT);
  }

  get prioritiesColWidth() {
    return !this.isEditItemDisabled && !this.isDeleteItemDisabled ? '4' : '3';
  }

  onClickAddPriorities() {
    this.priorityComp.createPriority();
  }

  onClickEditPriority(priority: StrtPriority) {
    this.priorityComp.editPriority(priority);
  }

  onPriorityCreate(priority: StrtPriority) {
    this.isPriorityActive = false;
    this.priorityCreate.emit(priority);
  }

  onPriorityEdit(priority: StrtPriority) {
    this.isPriorityActive = false;
    this.priorityEdit.emit(priority);
  }

  onItemError(error: Error) {
    this.isPriorityActive = false;
    super.onItemError(error);
  }

  getCellColor(cell, priority: StrtPriority) {
    cell.parentNode.style.background = priority.colorCode;
  }

  onRowReorder(event) {
    this.reorderInProgress = true;
    this._prioritySort.sortedPriorityIds = this.priorities.map((priority: StrtPriority) => {
      return priority.priorityId;
    });
    this.priorityService.sortPriorities(this._prioritySort).subscribe((result: any) => {
      this.prioritySort.emit(this.strategyId);
      setTimeout(() => {
        this.reorderInProgress = false;
      }, 500);
    }, (err: any) => {
      this.reorderFailed = true;
      setTimeout(() => {
        this.reorderInProgress = false;
        this.prioritySortFail.emit(this.planCoordinate);
      }, 3000);
    });
  }

}
